import { ReactNode } from 'react'

// Libs
import useActiveCategory from './hooks/useActiveCategory'
import { TabItemType } from './utils/types'

// Components
import CategoryTabs from './components/_shared/CategoryTabs'
import AllContent from './components/All'
import KolContent from './components/KOL'
import LivesContent from './components/Lives'
import ProductsContent from './components/Products'
import VendorsContent from './components/Vendor'

type CategoryContentMap = Record<TabItemType['value'], ReactNode>

const categoryContentMap: CategoryContentMap = {
  all: <AllContent />,
  live: <LivesContent />,
  products: <ProductsContent />,
  vendor: <VendorsContent />,
  kol: <KolContent />,
}

const SearchResults = () => {
  const activeCategory = useActiveCategory()
  return (
    <div>
      <CategoryTabs />
      {categoryContentMap[activeCategory]}
    </div>
  )
}

export default SearchResults
